import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import {useRuntimeConfig} from '#app';

const echoInstance = null;

export const useEcho = () => {
    if (!echoInstance) {

        if (import.meta.client) {
            const config = useRuntimeConfig().public;
            const appEnv = config.appEnv;

            if (typeof window !== 'undefined' && !window.Pusher) {
                window.Pusher = Pusher;
            }

            Pusher.logToConsole = appEnv === 'local';


            // Production config
            const echoInstance = new Echo({
                    broadcaster: 'reverb',
                    key: config.reverbAppKey,
                    cluster: config.reverbCluster,
                    wsHost: config.reverbHost,
                    wsPort: config.reverbPort,
                    wssPort:config.reverbPort,
                    forceTLS: true,
                    enabledStats: true,
                    enabledTransports: ['ws', 'wss'],
                });


            // Local config
            // Uncomment in local env and comment the production conifg

            // const echoInstance = new Echo({
            //     broadcaster: 'reverb',
            //     key: config.reverbAppKey,
            //     cluster: config.reverbCluster,
            //     wsHost: config.reverbHost,
            //     wsPort: config.reverbPort,
            //     forceTLS: false,
            //     enabledStats: true,
            //     enabledTransports: ['ws', 'wss']
            // });

            // Add error handling
            echoInstance.connector.pusher.connection.bind('error', (err) => {
                console.error('Echo connection error:', err);
            });

            return echoInstance;
        }
    }
};
